import { Component, OnInit } from '@angular/core';
import { SsrService } from 'src/app/services/ssr/ssr.service';

@Component({
  selector: 'app-manpuneet',
  templateUrl: './manpuneet.component.html',
  styleUrls: ['./manpuneet.component.scss']
})
export class ManpuneetComponent implements OnInit {
  result:{name:string ,title:string, link:string} [] = [];
  constructor(private ssrService : SsrService) { }

  ngOnInit(): void {
    this.result = this.ssrService.getManpu();
  }

}
